import React from "react";
import PropTypes from "prop-types";
import { ArrowDown, ArrowUp, Copy, Plus, Trash2 } from "lucide-react";

import Button from "./Button";
import IconButton from "./IconButton";

const RepeaterGroup = ({
  addLabel = "Add item",
  emptyMessage = "No items have been added.",
  itemLabel,
  items,
  minItems = 0,
  onAdd,
  onDuplicate,
  onMove,
  onRemove,
  renderItem,
  showAddButton = true,
}) => (
  <section className="wsm-repeater">
    {items.length === 0 && <p className="wsm-repeater__empty">{emptyMessage}</p>}
    <ol className="wsm-repeater__list">
      {items.map((item, index) => {
        const label = itemLabel(item, index);
        return (
          <li className="wsm-repeater__item" key={item.id}>
            <div className="wsm-repeater__header">
              <div><span className="wsm-repeater__index">{index + 1}</span><h3>{label}</h3></div>
              <div className="wsm-repeater__actions" aria-label={`Actions for ${label}`}>
                {onMove && <>
                  <IconButton aria-label={`Move ${label} up`} disabled={index === 0} icon={ArrowUp} onClick={() => onMove(index, index - 1)} size="compact" />
                  <IconButton aria-label={`Move ${label} down`} disabled={index === items.length - 1} icon={ArrowDown} onClick={() => onMove(index, index + 1)} size="compact" />
                </>}
                {onDuplicate && <IconButton aria-label={`Duplicate ${label}`} icon={Copy} onClick={() => onDuplicate(index)} size="compact" />}
                <IconButton aria-label={`Remove ${label}`} disabled={items.length <= minItems} icon={Trash2} onClick={() => onRemove(index)} size="compact" variant="destructive" />
              </div>
            </div>
            <div className="wsm-repeater__content">{renderItem(item, index)}</div>
          </li>
        );
      })}
    </ol>
    {showAddButton && <Button icon={Plus} onClick={onAdd} variant="outline">{addLabel}</Button>}
  </section>
);

RepeaterGroup.propTypes = {
  addLabel: PropTypes.string,
  emptyMessage: PropTypes.string,
  itemLabel: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired })).isRequired,
  minItems: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func,
  onMove: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  showAddButton: PropTypes.bool,
};

export default RepeaterGroup;
